import { createRoot } from 'react-dom/client';

import App from './App.tsx';
import 'react-toastify/dist/ReactToastify.css';
import './index.css';

createRoot(document.getElementById('root') as HTMLElement).render(<App />);
